import { cx } from 'emotion';
import React, { CSSProperties } from 'react';

import { DeviceInfo } from '@ezugi/utils';

import {
  Container,
  AnimationWrapper,
  rowClassName,
  mobileRow,
  overflowClassName,
  desktopClassName,
  mobileClassName,
} from './style';

type WinnerListRowProps = Readonly<{
  label: string;
  amount: string | number;
  style?: CSSProperties;
}>;

function WinnerListRow({ label, amount, style }: WinnerListRowProps) {
  return (
    <div
      className={cx(rowClassName, { [mobileRow]: DeviceInfo.isHandheld })}
      data-name="winner-list-row"
      key={`${label}-${amount}`}
      style={style}
    >
      <span className={cx('winner-list-label', overflowClassName)}>
        {label}
      </span>
      <span className="winner-list-amount">{amount}</span>
    </div>
  );
}

type Winner = {
  Nickname: string;
  WinAmount: string | number;
  style?: CSSProperties;
};

type WinnerListProps = {
  className?: string;
  style?: CSSProperties;
  list: Winner[];
  maxLength?: number;
  duration?: number;
  header?: React.FC | WinnerListRowProps;
};

const headerDefaultProps = {};

const WinnerList = ({
  list = [],
  className,
  style,
  duration = 5000,
  header = () => null,
  maxLength = Infinity,
}: WinnerListProps) => {
  const finalList = list.slice(0, maxLength);

  return (
    <Container
      style={style}
      data-name="winner-list"
      data-duration={duration}
      className={cx(
        DeviceInfo.isHandheld ? mobileClassName : desktopClassName,
        className
      )}
    >
      <AnimationWrapper
        style={
          {
            '--duration': `${duration}ms`,
          } as any
        }
      >
        {typeof header === 'function' ? (
          header(headerDefaultProps)
        ) : (
          <WinnerListRow
            label={header.label}
            amount={header.amount}
            style={{
              color: '#FF0',
              ...header.style,
            }}
          />
        )}
        {finalList.map(({ Nickname, WinAmount, style: winnerStyle }) => (
          <WinnerListRow
            key={Nickname}
            label={Nickname}
            amount={WinAmount}
            style={winnerStyle}
          />
        ))}
      </AnimationWrapper>
    </Container>
  );
};

export default WinnerList;
